import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CaseRecord } from '../interface/caseRecord.interface';
import { EnvService } from 'src/app/services/env.service';

@Injectable()
export class CaseRecordService {
  readonly baseUrl = `${this.env.URL_API_V1}/case_record`;

  constructor(private readonly http: HttpClient, private env: EnvService) { }

  filterData = new Subject();

  updatedRecord = new Subject<any>();
  createCaseRecord(caseRecord) {
    return (
      this.http
        .post<CaseRecord[]>(`${this.baseUrl}/create`, caseRecord)
        // .pipe(take(1))
        .subscribe()
    );
  }

  getAllCaseRecord(id) {
    return this.http.get<CaseRecord[]>(`${this.baseUrl}/getAll/${id}`);
  }
}
